import { MediumModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import CustomSelectSectionCustomers from '../../../../../../../specificComponents/Customers/CustomSelectSectionCustomers'
import { returnClassOfSpanTemplate } from '../../../../../../../utils/globals/tailwind'
import { CustomerPayload } from '../../../../../../../utils/reducers/customers/customer'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { TaskRepositoryModelTypeWithTags } from '../types'
import { useState } from 'react'
import TwinTagSelector from '../../../../../../../baseComponents/TwinTagSelector'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import useTaskRepositoryTags from '../../../../../../../utils/hooks/tasks/useTaskRepositoryTags'


type ModalCreateTaskRepositoryProps = ModalEditComponentProps & ReduxModalCreateTaskRepository & { }

const ModalCreateTaskRepository: React.FC<ModalCreateTaskRepositoryProps> = ({ userPermissions, allRowData, customers, ...rest }) => {
    const { t } = useTwinTranslation()
    const { data, setData } = useModalCreateTaskRepositoryLogic()
    const { addTag, removeTag, taskRepositoryTags } = useTaskRepositoryTags({ setData })
    const fields: FormRender<TaskRepositoryModelTypeWithTags> = [
        {
            cols: 3,
            elements: [
                {
                    name: 'title',
                    label: t('title', 'Título'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    className: returnClassOfSpanTemplate(2)
                },
                {
                    name: 'CustomerId',
                    component: 'Custom',
                    render: ({ extraProps }) => <CustomSelectSectionCustomers name='CustomerId' customers={extraProps.customers} label={t('customer', 'Cliente')} />,
                    extraProps: { customers }
                },
            ]
        },
        {
            cols: 1,
            title: t('tags', 'Etiquetas'),
            elements: [
                {
                    name: 'tagsForParse',
                    component: 'Custom',
                    render: ({ extraProps }) => <TwinTagSelector className='w-300' selectedTags={extraProps.data.tags} addTag={extraProps.addTag} removeTag={extraProps.removeTag} dictTags={extraProps.taskRepositoryTags || {}} />,
                    extraProps: {
                        data,
                        addTag,
                        removeTag,
                        taskRepositoryTags
                    }
                },
            ]
        },
        {
            cols: 1,
            elements: [
                {
                    name: 'description',
                    label: t('description', 'Description'),
                    component: 'TwinEditor',
                    className: 'task_repository_description',

                },
            ]
        }
    ]
    return (<MediumModalCreateEdit fields={fields} url={'/api/app/task/repository/createTaskRepository'} translations={{
        title: t('createIssue', 'Crear tema'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

const useModalCreateTaskRepositoryLogic = () => {
    const [data, setData] = useState<TwinDictionary | null>({tags: []})
    return { data, setData }
}

const modalCreateTaskRepositoryDispatch = {
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
}

export type ReduxModalCreateTaskRepository = ConnectedProps<typeof modalCreateTaskRepositoryConnect>
const mapModalCreateTaskRepositoryConnector = (state: AllReduxPayloads) => ({ customers: state.customers })
const modalCreateTaskRepositoryConnect = connect(mapModalCreateTaskRepositoryConnector, modalCreateTaskRepositoryDispatch)
const modalCreateTaskRepositoryConnectLoading = withLoading(ModalCreateTaskRepository, [{ fetchUrl: '/api/app/customer/getAllCustomersComplete', propName: 'customers', setFunctionName: 'setCustomers' }])
const ModalCreateTaskRepositoryConnect = modalCreateTaskRepositoryConnect(modalCreateTaskRepositoryConnectLoading)

export default ModalCreateTaskRepositoryConnect